module.exports = __webpack_public_path__ + "img/slider2.2ae9a614.jpg";